<template>
  <div id="forget">
    <!-- <div class="login-content__tab mar-b-30">
      <div :class="['login-content__tab__item ipub-h3 active']">
        <template>Sign In</template>
      </div>
      <div :class="['login-content__tab__item ipub-h3 mar-l-40']">
        <router-link to="register">Sign Up</router-link>
      </div>
    </div> -->
    <ipub-form ref="forget-form"
               :model="form"
               :rules="rules">
      <ipub-form-item prop="email"
                      label="Email">
        <ipub-input v-model.trim="form.email"
                    placeholder="Email" />
      </ipub-form-item>
      <ipub-form-item prop="code">
        <div class="flex-center">
          <ipub-input v-model.trim="form.code"
                      style="width:50%"
                      placeholder="Verification Code" />
          <img :src="code.code"
               @click="getCaptcha"
               class="ipub-c-p"
               style="width:calc(50% - 70px);height:40px;margin:0 10px"
               alt="">
          <a @click="getCaptcha"
             class="link-color">Refresh</a>
        </div>
      </ipub-form-item>
    </ipub-form>
    <ipub-button style="width:100%;margin-bottom:20px"
                 type="primary"
                 @click="submit">
      Recover Password
    </ipub-button>
    <div class="ipub-p3 tr font-color ioub-p3">
      Remeber my password.
      <router-link to="login"
                   class="link-color">Sign In</router-link>.
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
